//Mixin
Date.prototype.addHours = function (h) {
	this.setHours(this.getHours() + h);
	return this;
};
Date.prototype.removeHours = function (h) {
	this.setHours(this.getHours() - h);
	return this;
};

